// Debug logger for frontend
export const debugLog = (message: string, data?: unknown) => {
  const timestamp = new Date().toISOString();
  const prefix = `[FRONTEND DEBUG ${timestamp}]`;
  if (data) {
    console.log(prefix, message, data);
  } else {
    console.log(prefix, message);
  }
};
